export default __webpack_public_path__ + "99db5913ab28aa32b23e4180bea0f7c6.png";